import { render, staticRenderFns } from "./swfooter.vue?vue&type=template&id=9a90d992&scoped=true&"
import script from "./swfooter.vue?vue&type=script&lang=js&"
export * from "./swfooter.vue?vue&type=script&lang=js&"
import style0 from "./swfooter.vue?vue&type=style&index=0&id=9a90d992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a90d992",
  null
  
)

export default component.exports